import * as React from 'react';
import { Box } from '@lce/slice';
import { DealTile } from '../../lib/deals';

import * as Styled from './DealImage.style';
import { BannerLink } from '../../ui';

export interface IDealImageProps extends DealTile {
  link?: {
    url: string;
    text: string;
  };
}

export const DealImage: React.FC<IDealImageProps> = ({ image, link, ...props }) => (
    <Box as="section" {...props}>
      {link && image ? (
        <BannerLink data-testid="dealImage__banner-link" href={link.url} title={link.text}>
          <Styled.DealImage alt={image.alt} data-testid="dealimagetile-link" m="0 auto" src={image.url} />
        </BannerLink>
      ) : image && (
        <Styled.DealImage alt={image.alt} data-testid="dealimagetile" m="0 auto" src={image.url} />
      )}
    </Box>
  );
